<template>
  <div v-if="!isMobile">
    <v-navigation-drawer
      v-model="drawer"
      :mini-variant.sync="mini"
      app
      expand-on-hover
      width="220"
      mobile-breakpoint="600"
    >
      <v-list>
        <v-list-item class="px-2" >
          <v-list-item-avatar>
            <!-- <v-img
              src="https://randomuser.me/api/portraits/women/85.jpg"
            ></v-img> -->
            <!-- <v-img  
                src="/img/logo_noob.png
            "
              ></v-img> -->
            <!-- <v-icon size="48">mdi-account-circle</v-icon> -->
            <v-avatar>
              <v-img
                width="24"
                src="/img/logo_noob.png" />
            </v-avatar>
          </v-list-item-avatar>

        </v-list-item>
        <v-list-group >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title class="text-h6"> {{ $auth.name() }} </v-list-item-title>
              <v-list-item-subtitle>{{ $auth.email() }}</v-list-item-subtitle>
            </v-list-item-content>
          </template>
          <v-list-item @click="dialog = true" link>
            <v-list-item-icon>
              <v-icon size="24">mdi-account-key</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>เปลี่ยนรหัสผ่าน</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>

      <v-divider></v-divider>

      <v-list dense>
        <div v-for="item in items" :key="item.title">
          <v-list-group v-if="item.sub_items">
            <template v-slot:activator>
              <v-list-item-icon>
                <v-icon size="24">{{ item.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item
              v-for="sub_item in item.sub_items"
              :key="sub_item.title"
              link
              sub-group
              :to="sub_item.to"
            >
              <v-list-item-icon>
                <v-icon size="24">{{ sub_item.icon }}</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>{{ sub_item.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>

          <v-list-item v-else :to="item.to" link>
            <v-list-item-icon>
              <v-icon size="24">{{ item.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </div>

        <v-list-item
            v-if="$auth.isAdmin()"
            @click="$router.push({ name: 'Admin' })"
            link
          >
            <v-list-item-icon>
              <v-icon size="24">mdi-account-tie</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>ผู้ดูแลระบบ</v-list-item-title>
            </v-list-item-content>
        </v-list-item> 

        <v-list-item @click="aboutDialog = true" link>
          <v-list-item-icon>
            <v-icon size="24">mdi-information</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>เกี่ยวกับ</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <template v-slot:append>
        <v-list dense> 
          <v-list-item @click="logout" link>
            <v-list-item-icon>
              <v-icon size="24">mdi-logout</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>ออกจากระบบ</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </template>
    </v-navigation-drawer>
    <!-- about -->
    <v-dialog
      persistent
      v-model="aboutDialog"
      transition="dialog-top-transition"
      max-width="300"
    >
      <v-card class="card-shadow border-radius-xl">
        <v-card-title class="mt-0">
          <h5 class="text-h6 font-weight-bold text-typo">เกี่ยวกับ</h5>
          <v-spacer />
          <v-btn class="ma-0" fab icon @click="aboutDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-list>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>รุ่น</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>2.5.0</v-list-item-action>
            </v-list-item>
            <v-divider />
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>ผู้พัฒนา</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>สิทธิพงษ์ จันทร์สรณ์</v-list-item-action>
            </v-list-item>
            <v-divider />
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>Email</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>db4linq@gmail.com</v-list-item-action>
            </v-list-item>
            <v-divider />
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>โทรศัพท์</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>0863219053</v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- change password -->
    <v-dialog
      persistent
      v-model="dialog"
      transition="dialog-top-transition"
      max-width="600"
    >
      <v-form ref="form" v-model="valid">
        <v-card class="card-shadow border-radius-xl" id="change">
          <v-card-title class="mt-0">
            <h5 class="text-h5 font-weight-bold text-typo">Change Password</h5>
            <v-spacer />
            <v-btn class="ma-2" fab icon @click="close">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <div class="px-6 pb-6 pt-0">
            <v-row>
              <v-col cols="12">
                <v-text-field
                  label="Current password"
                  outlined
                  dense
                  type="password"
                  class="font-size-input input-style py-0"
                  v-model="editedItem.password"
                  :rules="[rules.required]"
                ></v-text-field>
                <v-text-field
                  label="New password"
                  outlined
                  dense
                  type="password"
                  class="font-size-input input-style py-0"
                  v-model="editedItem.newPassword"
                  :rules="[rules.required]"
                ></v-text-field>
                <v-text-field
                  label="Confirm new password"
                  outlined
                  dense
                  type="password"
                  class="font-size-input input-style py-0"
                  :rules="[
                    rules.required,
                    rules.confirmPassword(
                      editedItem.newPassword,
                      editedItem.confirmPassword
                    ),
                  ]"
                  v-model="editedItem.confirmPassword"
                ></v-text-field>
              </v-col>
            </v-row>

            <h5 class="mt-5 mb-2 text-h5 font-weight-bold text-typo">
              Password requirements
            </h5>
            <p class="text-muted font-weight-light mb-2">
              Please follow this guide for a strong password:
            </p>
            <div class="d-sm-flex">
              <ul class="text-muted ps-6 mb-0">
                <li>
                  <span class="text-sm">One special characters</span>
                </li>
                <li>
                  <span class="text-sm">Min 6 characters</span>
                </li>
                <li>
                  <span class="text-sm">One number (2 are recommended)</span>
                </li>
                <li>
                  <span class="text-sm">Change it often</span>
                </li>
              </ul>
              <v-btn
                color="#cb0c9f"
                class="font-weight-bolder btn-default bg-gradient-success py-4 px-8 ms-auto mt-sm-auto mt-4"
                small
                @click="save"
              >
                Update password
              </v-btn>
            </div>
          </div>
        </v-card>
      </v-form>
      <v-snackbar v-model="snackbar.show" :color="snackbar.color">
        {{ snackbar.text }}
        <template v-slot:action="{ attrs }">
          <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
            Close
          </v-btn>
        </template>
      </v-snackbar>
    </v-dialog>
  </div>
</template>

<script>
import Rules from "@/InputValidateRules";
export default {
  name: "DashboardCoreDrawer",
  data: () => ({
    isMobile: false,
    drawer: true,
    items: [
      { title: "หน้าหลัก", icon: "mdi-home-city", to: "/" },
      { title: "ฟาร์ม", icon: "mdi-home", to: "/farm", sub_items: [] },
      {
        title: "แผงควบคุม",
        icon: "mdi-view-dashboard",
        to: { name: "DashboardList" },
        sub_items: [
          { title: "จัดการแผงควบคุม", icon: "mdi-view-dashboard-edit", to: { name: "DashboardList" } },
        ]
      },
      // { title: "ผู้ดูแลระบบ", icon: "mdi-account-tie" },
    ],
    mini: true,
    desserts: [],
    dashboards: [],
    dialog: false,
    aboutDialog: false,
    valid: false,
    rules: Rules.rules,
    editedItem: {},
    snackbar: {
      show: false,
      text: "",
      color: "success",
    },
  }),
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
    // window.addEventListener("online", this.updateOnlineStatus);
    // window.addEventListener("offline", this.updateOnlineStatus);
    var _this = this;
    document.addEventListener("fullscreenchange", function () {
      console.log("fullscreenchange");
      //_this.isFullscreen = !_this.isFullscreen
    });
  },
  created() {
    this.refresh();
  },
  methods: {
    onResize() {
      this.isMobile = window.innerWidth < 600;
    },
    async save() {
      this.$refs.form.validate();
      console.log("VALID> ", this.valid);
      if (this.valid) {
        const result = await this.$auth.changePassword({
          _id: this.$auth.id(),
          oldPassword: this.editedItem.password,
          newPassword: this.editedItem.newPassword,
        });
        if (result) {
          this.snackbar.text =
            "เปลี่ยนรหัสผ่านสำเร็จ จะทำการลงชื่อเข้าใช้งานใหม่";
          this.snackbar.color = "success";
          this.snackbar.show = true;
        } else {
          this.snackbar.text = "เปลี่ยนรหัสผ่านไม่สำเร็จ";
          this.snackbar.color = "error";
          this.snackbar.show = true;
        }
      }
    },
    async close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.$refs.form.reset();
      });
    },
    logout() {
      this.$auth.logout();
    },
    async refresh() {
      this.desserts = await this.$api.FarmApi.getByUser(this.$auth.id());
      this.dashboards = await this.$api.DashboardApi.getByUser(this.$auth.id());
      console.log(this.desserts);
      for (let index = 0; index < this.desserts.length; index++) {
        const e = this.desserts[index];
        this.items[1].sub_items.push({
          title: e.title,
          icon: "mdi-hoop-house",
          to: { name: "Dashboard", params: { id: e._id } },
          // title: e.title, icon: "mdi-home-city", to: `/${e.title}/${e._id}`,
        });
      }
      console.log("dashboard: ", this.dashboards);
      for (let index = 0; index < this.dashboards.length; index++) {
        const e = this.dashboards[index];
        this.items[2].sub_items.push({
          title: e.name,
          icon: "mdi-monitor-dashboard",
          to: { name: "DashboarView", params: { id: e._id } },
          // title: e.title, icon: "mdi-home-city", to: `/${e.title}/${e._id}`,
        });
      }
    },
  },
};
</script>